/**
 *
 * FormTabs
 *
 * This is purely presentational and has state that is maintained by external
 * reducers and actions provided by the contianer this is used by.
 *
 * `renderForm` must be a function that returns a component to be rendered in
 * each tab
 *
 */

import React  from 'react';
import {
  Wrapper,
  Nav,
  Title,
  Button,
  Ul,
} from './styledComponents';
import FormTab from './FormTab';

import H1 from 'components/H1';

class FormTabs extends React.PureComponent {


  componentDidUpdate(prevProps, prevState) {
    if(prevProps.currentTab !== this.props.currentTab) {
      document.getElementById("root").childNodes[0].scrollTop = 0
    }
  }

  render() {
    const { onTabChange, tabs, currentTab, formTitle, onCancel, mementoPlan, isNew } = this.props;
    const { renderForm, disabled } = tabs[currentTab] || tabs[0];

    return (
      <Wrapper>
        <Nav>
          <Title>
            <H1>{formTitle}</H1>
            {onCancel &&
                <Button
                  className="cancel"
                  onClick={onCancel}
                  hidden={this.props.pristine}
                >Cancel</Button>
            }
          </Title>
          <Ul>
            {tabs.map((tab, i) =>
              <FormTab
                key={i}
                mementoPlan={mementoPlan}
                isActive={currentTab === i}
                onClick={() => onTabChange ? onTabChange(i) : undefined}
                disabledOthers={isNew && i > currentTab}
                {...tab}
              />
            )}
          </Ul>
        </Nav>
        {renderForm({ disabled })}
      </Wrapper>
    );
  }
}





export default FormTabs;



// WEBPACK FOOTER //
// ./src/components/FormTabs/index.js